/**
 * Client constants for the hosted-dev workspace role rotator.
 * Keep emails/roles in sync with functions/modules/workspaceRoleRotator.js.
 */

import { VALID_ROLES, ROLE_DISPLAY_NAMES } from '@/config/roles'

export const WORKSPACE_ROTATOR_EMAILS = ['admin@casemanagevue.com']

/** All app roles are available on the allowlisted hosted-dev demo login only. */
export const WORKSPACE_ROTATOR_EXCLUDED_ROLES = []

export const WORKSPACE_ROTATOR_ROLES = VALID_ROLES.filter(
  (role) => !WORKSPACE_ROTATOR_EXCLUDED_ROLES.includes(role)
).map((role) => ({
  value: role,
  label: ROLE_DISPLAY_NAMES[role] || role
}))

export function normalizeEmail(email) {
  return String(email || '')
    .trim()
    .toLowerCase()
}

export function isWorkspaceRotatorEmail(email) {
  return WORKSPACE_ROTATOR_EMAILS.includes(normalizeEmail(email))
}
